import React, { Component } from 'react'
import { StyleSheet, css } from 'aphrodite'
import Dialog from '@material-ui/core/Dialog'

import { AppStyles, AppTheme } from '../styles/AppTheme'
import { CustomMessageDialogStyles } from '../styles/CustomStyles'
import { AppConfig } from '../AppConfig'
import { UiHelper } from '../common/helpers/UiHelper'

import { Fade, Slide } from '@material-ui/core';
import { AppHelper } from '../helpers/AppHelper'
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export class DisplayWeblinkPreviewDialog extends Component {
  constructor(props) {
    super(props)
    this.state = {
      portrait:{
        width:1080,
        height:1920,
      },
      landscape:{
        width:1920,
        height:1080,
      },
      defaultOrientation:'portrait'
    }
  }

  onCloseModal() {
    this.props.onClosed()
  }
  changeState(orientation) {
    this.setState({
      defaultOrientation: orientation
    })
  }

  render() {
    return (
      <Dialog
        open={this.props.isOpen}
        aria-labelledby={this.props.title}
        fullWidth={AppHelper.fullWidthCondition()}
        fullScreen={AppHelper.fullWidthCondition()}
        TransitionComponent={window.innerWidth < 1024 ? Transition : Fade}
        maxWidth='md'
        classes={{
          root: css(Styles.root),
          paper: css(Styles.paper),
        }}
      >
        <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
          <div className={css(Styles.modalTitle)}>{this.props.title}</div>
          <button className={css(Styles.modalCloseButton)} onClick={this.onCloseModal.bind(this)} disabled={this.state.inProcess}>
            {UiHelper.renderImg({key:'dialogCloseIcon'})}
          </button>
        </div>
        <div className={css(Styles.modalContent)}>
          <div className={css(Styles[this.state.defaultOrientation + 'IframeHolder'])}>
            <iframe className={css(Styles.iframeWeblink)}
              src={this.props.adLink}
              height={this.state[this.state.defaultOrientation].height}
              width={this.state[this.state.defaultOrientation].width}
              frameborder='0' title={this.props.title}></iframe>
          </div>
        </div>
        <div className={css(Styles.dialogFooterBlock)}>
          <button className={css(Styles.orientationChangeButton)}>
            {this.state.defaultOrientation === 'portrait' && <i className={'material-icons-outlined ' + css(Styles.viewChangeIcon)} onClick={() => { this.changeState('landscape') }} title={'Click for Landscape preview'}>stay_primary_landscape</i>}
            {this.state.defaultOrientation === 'landscape' && <i className={'material-icons-outlined ' + css(Styles.viewChangeIcon)} onClick={() => { this.changeState('portrait') }} title={'Click for Portrait preview'}>stay_primary_portrait</i>}
          </button>
        </div>
      </Dialog>
    )
  }
}

const Styles = AppConfig.CUSTOM_STYLE ? CustomMessageDialogStyles : StyleSheet.create({
  modalHeader: {
    padding: 20,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 14
  },
  modalTitle: {
    color: '#222222',
    fontSize: 18,
    maxWidth: 180,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  modalContent: {
    maxWidth: 610,
    minWidth: 200,
    paddingTop: 16,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 10,
  },
  modalCloseButton: {
    position: 'absolute',
    top: 23,
    right: 30,
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
  },
  modalCloseIcon: {
    width: 18,
    height: 18,
    padding: 1,
    fill: 'black',
    borderRadius: AppTheme.borderRadius
  },
  root: {
    zIndex: 13000,
  },
  paper: {
    borderRadius: AppTheme.borderRadius,
    '@media (max-width: 1024px)': {
      maxHeight: 'calc(100% - 140px) !important',
      borderRadius: '20px 20px 0 0',
      bottom: '0 !important',
      position: 'fixed',
      height: 'auto !important'
    }
  },
  contentImage: {
    maxWidth: '100%',
    maxHeight: 400,
    border: 'solid black 1px'
  },
  contentVideo: {
    width: '100%',
    height: 'auto',
    maxHeight: 400
  },
  dialogFooterBlock: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    paddingBottom:15
  },
  orientationChangeButton: {
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer'
  },
  portraitIframeHolder: {
    width: 342,
    height: 610 ,
    overflow: 'hidden',
    border: AppTheme.borderColor + ' solid 1px'
  },
  landscapeIframeHolder: {
    width: 610,
    height: 342,
    overflow: 'hidden',
    border: AppTheme.borderColor + ' solid 1px'
  },
  iframeWeblink: {
    transform: 'scale(0.3166)',
    transformOrigin: 'top left',
    background: AppTheme.backgroundColor
  }
})



// WEBPACK FOOTER //
// ./src/components/DisplayWeblinkPreviewDialog.js